export default __webpack_public_path__ + "static/media/chartres11.48286cae.jpg";